import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const StoreAddress = ({ address }) => (_jsxs(_Fragment, { children: [`${address.street} ${address.number}`, address.bus && ` ${address.bus}`, _jsx("br", {}), `${address.zipCode} ${address.city}`] }));
